import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatabaseService } from '../../services/database/database.service';
import { CommonModule } from '@angular/common';
import { QS } from '../../../models/database';

@Component({
  selector: 'app-qs-modal-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './qs-modal-component.component.html',
  styleUrl: './qs-modal-component.component.scss'
})
export class QsModalComponentComponent {

  qas: QS | null = null

    constructor(
      private activeModal: NgbActiveModal,
      private databaseService: DatabaseService
    ){}

    ngOnInit(): void {
      // this.loadingFAQs();
    }

    // loadingFAQs(){
    //   this.databaseService.getQUCIKSTART().subscribe((data) => {
    //     this.qas = data
    //   })
    // }

    onCancel() {
      this.activeModal.dismiss();
    }

}
